<app-header></app-header>
<div class="container">
  <div class="content">
    <h1>{{ 'home.sections.main_title' | translate | async }}</h1>
    <div class="illustration-block">
      <div>
        <p class="subtitle main-description">{{ 'home.sections.main_description' | translate | async }}</p>
        <p class="subtitle">{{ 'home.sections.description_p1' | translate | async }}<br>{{ 'home.sections.description_p2' | translate | async }}</p>
        <div class="cta-block mobile">
          <a mat-flat-button [routerLink]="[langPart+'/playarea']" color="primary">{{ 'home.sections.cta.lets_begin' | translate | async }}</a>
        </div>
        <div class="grid">
          <div>
            <div class="icon-cont icon3">
              <img src="/assets/icons/robot-idea-128.webp" alt="Xedoom AI Icon">
            </div>
            <div>
              <h2>{{ 'home.sections.features.ai_section.title' | translate | async }}</h2>
              <p class="bold">{{ 'home.sections.features.ai_section.text1' | translate | async }}</p>
              <p>{{ 'home.sections.features.ai_section.text2' | translate | async }}</p>
            </div>
          </div>
          <div>
            <div class="icon-cont icon4">
              <img src="/assets/icons/problem-solve-128.webp" alt="Game Builder Icon">
            </div>
            <div>
              <h2>{{ 'home.sections.features.game_builder_section.title' | translate | async }}</h2>
              <p class="bold">{{ 'home.sections.features.game_builder_section.text1' | translate | async }}</p>
              <p>{{ 'home.sections.features.game_builder_section.text2' | translate | async }}</p>
            </div>
          </div>
        </div>
        <p class="mb-0">{{ 'home.sections.features.learn_more' | translate | async }} <a [routerLink]="[langPart+'/features']">{{ 'home.sections.features.features_page' | translate | async }}</a>.</p>
      </div>
    </div>
    <div class="cta-block">
      <p class="mb-0">{{ 'home.sections.cta.ready_dive' | translate | async }}</p>
      <div class="all-games">
        <div class="button-cont">
          <a mat-stroked-button [routerLink]="[langPart+'/auth/register']" color="warn">{{ 'home.sections.cta.create_account' | translate | async }}</a>
        </div>
        <div class="separator"></div>
      </div>
    </div>
    <div class="section">
      <h2>{{ 'home.sections.new_games' | translate | async }}</h2>
      <div class="games-list">
        @if (categories.publicQuizzes && categories.publicQuizzes.list.length > 0) {
          @for(game of categories.publicQuizzes.list; track game.id) {
            <app-game-card [whiteStyle]="true" [game]="game" [loading]="gameLoading" (startGame)="onGameStart($event)" [urlLangPart]="langPart"></app-game-card>
          }
        } @else {
          <div class="loading games"><span>{{ 'home.sections.loading_games' | translate | async }}</span></div>
        }
      </div>
      <div class="all-games">
        <div class="button-cont">
          <a mat-stroked-button [routerLink]="[langPart+'/playarea']" color="warn">{{ 'header.navigation.all-games' | translate | async }}</a>
        </div>
        <div class="separator"></div>
      </div>
    </div>

    <!-- <div class="illustration">
      <img loading="eager" src="{{cdn + '/images/group-of-friends.webp'}}" alt="A group of friends" width="400" height="400">
    </div> -->

    <div class="section">
      <h2>{{ 'home.sections.upcoming_features.title' | translate | async }}</h2>
      <p [innerHTML]="'home.sections.upcoming_features.description' | translate:version | async"></p>
      <p><strong>{{ 'home.sections.upcoming_features.next_update' | translate | async }}</strong></p>
      <div class="roadmap future">
        @for(roadMapEvent of roadMapEvents; track roadMapEvent.id) {
          <div class="roadmap-item">
            <div class="version">v{{ roadMapEvent.extra }}</div>
            <div class="date">{{ roadMapEvent.eventDate | date: 'longDate' }}</div>
            <div class="event">
              <h3>{{ roadMapEvent.title }}</h3>
              <p>{{ roadMapEvent.content }}</p>
            </div>
          </div>
        }
      </div>
      <p>{{ 'home.sections.upcoming_features.discover_more' | translate | async }} <a [routerLink]="[langPart+'/roadmap']">{{ 'home.sections.upcoming_features.roadmap_page' | translate | async }}</a>.</p>
    </div>
    <div class="separator"></div>
    <div class="section">
      <h2>{{ 'home.sections.news.title' | translate | async }}</h2>
      <div class="news-list">
        @if (newsList.length > 0) {
          @for(news of newsList; track news.id) {
            <div class="post">
              <div>
                <div class="date">{{ news.publishedAt | date: 'longDate' }}</div>
                <h3>{{ news.title }}</h3>
              </div>
            <p>{{ news.content }}</p>
          </div>
        }
      } @else {
        <div class="loading news"><span>{{ 'home.sections.news.loading' | translate | async }}</span></div>
      }
      </div>
      <p>{{ 'home.sections.news.discover_more' | translate | async }} <a [routerLink]="[langPart+'/news']">{{ 'home.sections.news.news_page' | translate | async }}</a>.</p>
    </div>
    <div class="separator"></div>
    <div class="section">
      <h2>{{ 'home.sections.cooperation.title' | translate | async }}</h2>
      <p [innerHTML]="'home.sections.cooperation.description' | translate | async"></p></div>
    <div class="cta-block">
      <p class="mb-0">{{ 'home.sections.cta.ready_play' | translate | async }}</p>
      <div class="all-games">
        <div class="button-cont">
          <a mat-stroked-button [routerLink]="[langPart+'/auth/register']" color="warn">{{ 'home.sections.cta.create_account' | translate | async }}</a>
        </div>
      </div>
    </div>
    <div class="illustration">
      <img loading="lazy" src="{{cdn + '/images/playing-charades.webp'}}" alt="Playing charades" width="400" height="400">
    </div>
  </div>
</div>
<app-scroll-to-top></app-scroll-to-top>
<app-footer></app-footer>
